import React from 'react';

const RedirectSignIn = () => {
  window.location.href = `${process.env.REACT_APP_AUTH}/#/sign-in?redirectUri=${encodeURIComponent(window.location.href)}`;
  return (<span></span>);
}

export default RedirectSignIn;